
import ContactFormInputs from "./ContactFormInputs.vue";

export default {
  props: ["subject", "isAgent"],
  components: { ContactFormInputs },
  data() {
    return {
      isVisiable: false,
    };
  },
  methods: {
    show() {
      this.isVisiable = true;
    },
  },
  mounted() {
    this.$vuetify.rtl = true;
  },
};
